export const UPDATE_SHARED_PRODUCT_TYPES = 'UPDATE_SHARED_PRODUCT_TYPES';

const INITIAL_STATE = {
    productTypes: [],
    allTenors: [],
    brokerages: [],
    countries: []
};

export const updateSharedData = (data) => {
    return async (dispatch) => {
        dispatch({
            type: UPDATE_SHARED_PRODUCT_TYPES,
            data
        });
    };
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_SHARED_PRODUCT_TYPES:
            return {
                ...state,
                ...action.data
            };

        default:
            return state;
    }
};

export default reducer;
